import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lowcode-page" }
const _hoisted_2 = { class: "filter-bar" }
const _hoisted_3 = { class: "action-bar" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LowcodePage',
  setup(__props) {

const filters = ref({ name: '', type: '' })
const selectedRowKeys = ref([])
const dataSource = ref([
  {
    id: 1,
    name: '设备监控仪表盘',
    type: '仪表盘',
    creator: 'admin',
    createdAt: '2024-05-01 10:00:00',
    status: '启用'
  },
  {
    id: 2,
    name: '设备登记表单',
    type: '表单',
    creator: '张三',
    createdAt: '2024-05-02 09:30:00',
    status: '停用'
  },
  {
    id: 3,
    name: '自定义页面A',
    type: '自定义',
    creator: '李四',
    createdAt: '2024-05-03 14:20:00',
    status: '启用'
  }
])

const columns = [
  { title: '页面名称', dataIndex: 'name', key: 'name' },
  { title: '类型', dataIndex: 'type', key: 'type' },
  { title: '创建人', dataIndex: 'creator', key: 'creator' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '状态', dataIndex: 'status', key: 'status' },
  { title: '操作', key: 'action' }
]

function onSearch() {}
function onReset() { filters.value = { name: '', type: '' } }
function onAdd() {
  window.open('http://localhost:9528/__vtj__/#/', '_blank')
}
function onEdit(record: any) {}
function onDelete(record: any) {}
function onBatchDelete() {}
function onSelectChange(keys: any) { selectedRowKeys.value = keys }

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_form, { layout: "inline" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "页面名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: filters.value.name,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.name) = $event)),
                    placeholder: "请输入页面名称",
                    style: {"width":"180px"}
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "类型" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: filters.value.type,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.type) = $event)),
                    placeholder: "请选择类型",
                    style: {"width":"120px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "" }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("全部")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "dashboard" }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("仪表盘")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "form" }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("表单")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "custom" }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("自定义")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: onSearch,
                    style: {"margin-right":"8px"}
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("查询")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_a_button, { onClick: onReset }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("重置")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: onAdd,
            style: {"margin-right":"8px"}
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("新建页面")
            ])),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "danger",
            disabled: !selectedRowKeys.value.length,
            onClick: onBatchDelete
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("批量删除")
            ])),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode(_component_a_table, {
          rowKey: "id",
          columns: columns,
          "data-source": dataSource.value,
          "row-selection": { selectedRowKeys: selectedRowKeys.value, onChange: onSelectChange },
          pagination: false,
          style: {"margin-top":"16px"}
        }, {
          emptyText: _withCtx(() => [
            _createVNode(_component_a_empty, { description: "暂无数据" })
          ]),
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (onEdit(record)),
                    style: {"color":"#1677ff","margin-right":"8px"}
                  }, "编辑", 8, _hoisted_4),
                  _createElementVNode("a", {
                    onClick: ($event: any) => (onDelete(record)),
                    style: {"color":"#ff4d4f"}
                  }, "删除", 8, _hoisted_5)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data-source", "row-selection"])
      ]),
      _: 1
    })
  ]))
}
}

})